import {Component, DestroyRef, inject} from '@angular/core';
import {MatButton} from '@angular/material/button';
import {MatCard, MatCardContent} from '@angular/material/card';
import {ActivatedRoute, RouterLink} from '@angular/router';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {TranslocoModule} from '@jsverse/transloco';

// Story 28.3 AC5 — the verify-email Lambda's success target. Shows a confirmation
// and, when the originating app supplied a return_url, a "Continue to {app}"
// button. With no app context it falls back to a "Go to sign in" link.
@Component({
  selector: 'app-email-verified',
  standalone: true,
  imports: [MatButton, MatCard, MatCardContent, RouterLink, TranslocoModule],
  templateUrl: './email-verified.component.html',
  styleUrl: './email-verified.component.css',
})
export class EmailVerifiedComponent {
  protected appName = '';
  protected returnUrl = '';

  private readonly route = inject(ActivatedRoute);
  private readonly destroyRef = inject(DestroyRef);

  constructor() {
    this.route.queryParams.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(params => {
      this.appName = params['app_name'] || '';
      this.returnUrl = params['return_url'] || '';
    });
  }

  // Cross-origin navigation back to the originating application (not the Angular
  // router — return_url is an external host). Guard against open-redirect: only
  // follow http(s) URLs; crafted direct links with javascript:/data: schemes are
  // rejected silently (the button simply does nothing).
  continueToApp(): void {
    if (this.returnUrl && (this.returnUrl.startsWith('https://') || this.returnUrl.startsWith('http://'))) {
      window.location.href = this.returnUrl;
    }
  }
}
